import axios from "axios";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useFieldArray, useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
  useUpdateSettingsMutation,
} from "../../../services/settingsApi";
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import { useUploadPhotoMutation } from "../../../services/photoApi";
import PackageModal from "../../Common/Modal/PackageModal";
import { Link } from "react-router-dom";
import PhotoUploadSquare from "../../Common/photoUpload/PhotoUploadSquare";
import PhotoUploader from "../../Common/photoUpload/photoUpload";
//icons
import { CiDeliveryTruck, CiSaveUp2 } from "react-icons/ci";
import { IoSave } from "react-icons/io5";
import { MdPayment } from "react-icons/md";

const PartnerApiSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);

  // console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      partnerAPI: {
        couriers: [
          {
            name: "",
            apiKey: "",
            apiUrl: "",
            serviceType: "",
            isActive: true,
          },
        ],
        payments: [
          {
            name: "",
            apiKey: "",
            apiSecret: "",
            apiUrl: "",
            callbackUrl: "",
            methodType: "",
            isActive: true,
          },
        ],
      },
    },
  });

  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  const {
    fields: courierFields,
    append: appendCourier,
    remove: removeCourier,
  } = useFieldArray({
    control,
    name: "partnerAPI.couriers",
  });

  const {
    fields: paymentFields,
    append: appendPayment,
    remove: removePayment,
  } = useFieldArray({
    control,
    name: "partnerAPI.payments",
  });

  return (
    <div>
      {/* Partner API Settings Section */}
      <form
        style={{ marginTop: "80px" }}
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "Partner API settings updated successfully!")
        )}
      >
        <div className="mb-4">
          <h5 className="d-flex align-content-center gap-2">
          <Icons.ServerOutline size={25} />  Partner API Integration
          </h5>
          <hr />

          {/* Couriers Section */}
          <h6>
            <CiDeliveryTruck size={20} /> Courier Partners
          </h6>
          {courierFields.map((item, index) => (
            <div className="card p-3 mb-3" key={item.id}>
              <div className="row mb-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Courier Name"
                    {...register(`partnerAPI.couriers.${index}.name`)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="API Key"
                    {...register(`partnerAPI.couriers.${index}.apiKey`)}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="API URL"
                    {...register(`partnerAPI.couriers.${index}.apiUrl`)}
                  />
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    {...register(`partnerAPI.couriers.${index}.serviceType`)}
                  >
                    <option value="">Select Service Type</option>
                    <option value="home_delivery">Home Delivery</option>
                    <option value="pickup_point">Pickup Point</option>
                  </select>
                </div>
                <div className="col-md-2 d-flex align-items-center">
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      {...register(`partnerAPI.couriers.${index}.isActive`)}
                    />
                    <label className="form-check-label">Active</label>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => removeCourier(index)}
                >
                  Remove Courier
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-dark mb-4"
            onClick={() =>
              appendCourier({
                name: "",
                apiKey: "",
                apiUrl: "",
                serviceType: "",
                isActive: true,
              })
            }
          >
            Add Courier
          </button>

          {/* Payments Section */}
          <h6>
            {" "}
            <MdPayment size={20} /> Payment Gateways
          </h6>
          {paymentFields.map((item, index) => (
            <div className="card p-3 mb-3" key={item.id}>
              <div className="row mb-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Gateway Name"
                    {...register(`partnerAPI.payments.${index}.name`)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="API Key"
                    {...register(`partnerAPI.payments.${index}.apiKey`)}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="API Secret"
                    {...register(`partnerAPI.payments.${index}.apiSecret`)}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="API URL"
                    {...register(`partnerAPI.payments.${index}.apiUrl`)}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Callback URL"
                    {...register(`partnerAPI.payments.${index}.callbackUrl`)}
                  />
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    {...register(`partnerAPI.payments.${index}.methodType`)}
                  >
                    <option value="">Select Method</option>
                    <option value="mobile_wallet">Mobile Wallet</option>
                    <option value="card">Card</option>
                    <option value="bank">Bank</option>
                  </select>
                </div>
                <div className="col-md-2 d-flex align-items-center">
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      {...register(`partnerAPI.payments.${index}.isActive`)}
                    />
                    <label className="form-check-label">Active</label>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => removePayment(index)}
                >
                  Remove Payment
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-dark"
            onClick={() =>
              appendPayment({
                name: "",
                apiKey: "",
                apiSecret: "",
                apiUrl: "",
                callbackUrl: "",
                methodType: "",
                isActive: true,
              })
            }
          >
            Add Payment Gateway
          </button>

          {/* Submit */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1" />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default PartnerApiSettings;
